export default {
  name: 'ReviewsProductBlock',
  props: {
    item: {
      type: Object,
      required: true
    },
    forceHeight: {
      type: Number,
      default: 0
    }
  }
}
